/** eslint-disable */
import * as process from 'process';

// 获取命令行参数
const args = process.argv.slice(2);
if (!(args.length && args.includes('--entries-only=sdk')) && process.env.QUALIFY_ENV !== 'sdk') {
    import('./app.global.less').then(() => {
        // 区分所加载的样式
        console.log('Global styles loaded');
    });
}